import { render, staticRenderFns } from "./Carousa.vue?vue&type=template&id=4571b858&"
import script from "./Carousa.vue?vue&type=script&lang=js&"
export * from "./Carousa.vue?vue&type=script&lang=js&"
import style0 from "./Carousa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports